import { warningColor } from "./status/warning.js";
const warning = (mode)=>{
    const color = warningColor(mode);
    return {
        main: color.main,
        light: 'light' === mode ? color.lowContrast : color.highContrast,
        dark: 'light' === mode ? color.highContrast : color.lowContrast
    };
};
export { warning };

//# sourceMappingURL=warning.js.map